<script setup lang="ts">
import { ref } from 'vue'

import { Popover } from '@collector/shared-ui'
import { CommonResultId, ResultId } from '@collector/sportsapi-client-legacy'
import Result from '@desktop/views/Relation/components/RelationView/Summary/Result.vue'
import {
  useParticipantResult,
  useSport,
} from '@desktop/views/Relation/composables'

const { sport } = useSport()
const { getHomeParticipantResult, getAwayParticipantResult } =
  useParticipantResult()

const results: ResultId[] = [CommonResultId.Winner, CommonResultId.Progress]

const sportResults = sport.value.results
  .filter(({ id, type }) => !results.includes(id) && type === 'team')
  .map(({ id, name }) => ({
    id,
    name,
  }))

const isPopoverOpen = ref(false)
</script>

<template>
  <Popover
    v-model="isPopoverOpen"
    :withCloseIcon="false"
    :trigger="{
      class: 'w-full',
      asChild: true,
    }"
  >
    <template #trigger>
      <Result
        :class="{
          'hover:underline': !isPopoverOpen,
        }"
      />
    </template>
    <template #content>
      <div class="grid grid-flow-col grid-cols-2 grid-rows-4 gap-x-4">
        <div
          v-for="(result, index) in sportResults"
          :key="index"
          class="flex min-h-6 items-center justify-between gap-2 rounded-sm px-1 @md:gap-4"
          :class="{
            'bg-neutral-light-10': index % 2 === 0,
          }"
        >
          <div class="text-xs">
            {{ result.name }}
          </div>
          <div
            class="flex justify-center gap-2 pr-1 text-sm font-bold @md:pr-4"
          >
            <span>
              {{ getHomeParticipantResult(result.id) }}
            </span>
            <span>:</span>
            <span>
              {{ getAwayParticipantResult(result.id) }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </Popover>
</template>
